var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"font-weight-bold d-flex flex-row m-t-10"},[_c('div',{style:({ width: '100%' })},[_c('custom-point-table',{ref:'customPointTable',on:{"reSearch":_vm.reSearch}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }